<template>
  <nav aria-label="Breadcrumb">
    <ol class="inline-flex flex-wrap justify-start gap-2">
      <li
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.path"
        class="border-r pr-2 text-xs font-bold last-of-type:border-none lg:font-semibold"
        :class="[
          isWhiteText
            ? 'border-gray-50 text-gray-50 last-of-type:text-gray-100'
            : 'border-gray-300 text-gray-300 last-of-type:text-gray-500',
        ]"
      >
        <NuxtLink v-if="breadcrumb.path" :to="formatLink(breadcrumb.path)">
          {{ breadcrumb.name }}
        </NuxtLink>
        <span v-else>
          {{ breadcrumb.name }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
defineProps({
  isWhiteText: {
    type: Boolean,
    default: false,
  },
})
const { breadcrumbs } = useBreadcrumbs()
const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)
</script>
